import React from "react";
import {
  FaBookOpen,
  FaChalkboardTeacher,

  FaProjectDiagram,
  FaGlobe,
  FaLightbulb,
  FaHandsHelping,
} from "react-icons/fa";
import "./MiddleSchool.css";

const MiddleSchool = () => {
  return (
    <div className="middle-school-page">
      {/* Hero Section */}
      <section className="middle-section">
        <h1>
          <FaBookOpen className="icon" /> Explore Grades 3 to 8 at Academic Group of Schools and College
          
        </h1>
        <p>
         Academic Group of Schools and College (AGS) upholds a clear mission – to prepare
          children for the demands of tomorrow by equipping them with the
          knowledge, skills, and values needed to excel in an ever-changing
          world. Guided by our motto, <strong>STEM, SKILLS, SERVICE</strong>, we
          place equal emphasis on academic excellence, personal growth, and
          social responsibility.
        </p>
        <p>
          As a world-class STEM school, we integrate subjects across a variety
          of disciplines and focus on expanding the core technical knowledge and
          skills of our students in areas of Science, Engineering, Technology
          and Mathematics – preparing them for an increasingly
          technology-based world.
        </p>
        <p>
          At AGS, education goes beyond textbooks. We focus on building strong
          moral foundations, critical thinking, and a sense of purpose, shaping
          students into capable, compassionate, and forward-looking individuals.
        </p>
        <p>
          As we continue to grow, we welcome you to join us in inspiring and
          empowering the next generation.
        </p>
      </section>

      {/* Approach Section */}
      <section className="middle-section">
        <h2>
          <FaChalkboardTeacher className="icon" /> Our Educational Approach -
          Grades 3 to 8
        </h2>
        <p>
          Tailored for grades 3 through 8, our educational approach is centred
          on excellence and holistic development. We have developed curricula
          that fosters lifelong learning, employing innovative teaching methods
          including <strong>PBL</strong>.
        </p>
      </section>

      <section className="middle-section">
        <h2>
          <FaProjectDiagram className="icon" /> Skills & Holistic Development
        </h2>
        <p>
          Our focus extends beyond academics to include the cultivation of
          essential skills, technological proficiency and comprehensive
          knowledge. Through our skills programme, we nurture an entrepreneurial
          mindset, fostering creativity, critical thinking and problem-solving
          abilities. Committed to sustainability, we actively engage in
          environmental conservation efforts.
        </p>
      </section>

      <section className="middle-section">
        <h2>
          <FaGlobe className="icon" /> Language Proficiency
        </h2>
        <p>
          Language proficiency is foundational, with an emphasis on reading,
          writing, vocabulary, speaking and listening skills. Together, these
          elements form a comprehensive educational experience that prepares
          students for success in a dynamic world.
        </p>
      </section>

      <section className="middle-section">
        <h2>
          <FaLightbulb className="icon" /> Lifelong Learning Mindset
        </h2>
        <p>
          By blending academics with innovation, personal growth, and
          responsibility, AGS fosters in students the curiosity and resilience
          they need to embrace lifelong learning and thrive in a global society.
        </p>
      </section>

      <section className="middle-section">
        <h2>
          <FaHandsHelping className="icon" /> Building Future Leaders
        </h2>
        <p>
          AGS aims to shape responsible leaders who not only excel academically
          but also embody compassion, service, and a forward-looking vision for
          society.
        </p>
      </section>
    </div>
  );
};

export default MiddleSchool;
